// extracted by mini-css-extract-plugin
module.exports = {"preStyle":"Styles_preStyle__1uYd0"};